var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',{ref:"inputRef",staticStyle:{"border-radius":"9px"},attrs:{"label":_vm.label,"outlined":"","prepend-icon":_vm.$props['prepend-icon'],"color":"#FFD79C","value":_vm.formattedValue,"hide-details":"","error-messages":_vm.validationErrors,"suffix":"zł","disabled":_vm.disabled}})
}
var staticRenderFns = []

export { render, staticRenderFns }